import React, { useState } from "react";

import "./SIdebar.css";

// import Button from 'react-bootstrap/Button';
// import Offcanvas from 'react-bootstrap/Offcanvas';
import Logo from "../../images/logo.png";
import Logosm from "../../images/logo-sm.png";
import Menu from "../../images/menu-bar.png";

import ProgressSide from "./ProSide";
import { Link } from "react-router-dom";
import Dropdown from "../dorpdown/Dropdown";


function Sidebar({handleToggle,isActive, handleMain, main}) {
   
  const [selected, setSelected] = useState("Active");
  

  
  return (
    <>
      <div className={isActive ? "isActive" : "sidebar"}>
        <div className="logo-menu">
          <div className="logo">
            <Link to="/">
              <img src={Logo} className="logo-lg" alt="" />
              <img src={Logosm} className="logo-sm" alt="" />{" "}
            </Link>
          </div>

          <div className="menubar" onClick={()=>handleToggle()}>
            <img src={Menu} alt="" />
          </div>
        </div>
        <div className="sidebar-menu">
          <div className="filter">
            <h5>Filter</h5>
          </div>
          <div className="select">
            <Dropdown selected={selected} setSelected={setSelected} />
            {/* <Search/> */}
        <Link to="/trs">
        <div className={main === 1 ? "prograss-bar lb1 slect" : "prograss-bar lb1"} main={main} onClick={()=>{handleMain(1)}}>
              <div className="label" 
              
              >
                <label htmlFor="">Belt jig 6</label>
                <label htmlFor="">82%</label>
              </div>
              <div   className="pro-br progres-bar1 ">
                <ProgressSide  done={82} />
              </div>
            </div>
        </Link>
          <Link to="/trs">
          <div className={main === 2 ? "prograss-bar lb1 slect" : "prograss-bar lb1"} main={main} onClick={()=>{handleMain(2)}}>
              <div className="label">
                <label htmlFor="">Belt jig 2</label>
                <label htmlFor="">58%</label>
              </div>
              <div className="pro-br progres-bar2"   >
                <ProgressSide done={58} />
              </div>
            </div>
          </Link>
           <Link to="/trs">
           <div className={main === 3 ? "prograss-bar lb1 slect" : "prograss-bar lb1"} main={main} onClick={()=>{handleMain(3)}}>
              <div className="label">
                <label htmlFor="">Belt jig 5</label>
                <label htmlFor="">20%</label>
              </div>
              <div className="pro-br progres-bar3"   >
                <ProgressSide done={20} />
              </div>
            </div>
           </Link>
          <Link to='/trs'>  <div className={main === 4 ? "prograss-bar lb1 slect" : "prograss-bar lb1"} main={main} onClick={()=>{handleMain(4)}}>
              <div className="label">
                <label htmlFor="">Belt jig 4</label>
                <label htmlFor="">100%</label>
              </div>
              <div className="pro-br progres-bar4"   >
                <ProgressSide done={100} />
              </div>
            </div></Link>
            <Link to="/trs"><div className={main === 5 ? "prograss-bar lb1 slect" : "prograss-bar lb1"} main={main} onClick={()=>{handleMain(5)}}>
              <div className="label">
                <label htmlFor="">Belt jig 1</label>
                <label htmlFor="">E 30</label>
              </div>
              <div className="pro-br progres-bar5"   >
                <ProgressSide done={70} />
              </div>
            </div></Link>
          </div>
        </div>
      </div>
     
    </>
  );
}

export default Sidebar;
